import React, { useState, useEffect } from 'react';
// Context
import { useCTALogTypesData } from '../../../../context/CTALogTypesContext';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
// Components
import Loading from '../../../../components/loading/Loading';
import { toastSuccess, toastError } from '../../../../components/feedback/Feedback';
// Form
import useInput from '../../../../components/form/hooks/useInput';
import DefaultInput from '../../../../components/form/inputs/DefaultInput';
import { isNotEmpty } from '../../../../components/form/validator/ValidatorRules';
import { isMandatoryMessage } from '../../../../components/form/validator/ValidatorMessages';
// Actions
import { savetypes as CTALogTypeSave } from '../../../../actions/ctalogs';

export default function CTALogTypeForm({ CTALogType, handleCloseModal }) {
  // Form
  const {
    value: nameValue,
    isValid: nameIsValid,
    hasError: nameHasError,
    valueChangeHandler: nameChangeHandler,
    inputBlurHandler: nameBlurHandler,
  } = useInput(isNotEmpty);

  let formIsValid = false;

  if (nameIsValid) {
    formIsValid = true;
  }

  // Context
  const { state, dispatch } = useCTALogTypesData();

  // State
  const [isLoading, setIsLoading] = useState(false);

  // useEffect
  useEffect(
    () => {
      if (CTALogType) {
        nameChangeHandler(CTALogType.name);
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Methods
  const validateAllFormInputs = () => {
    nameBlurHandler();
    nameChangeHandler(nameValue);
  };

  const saveCTALogType = async () => {
    setIsLoading(true);

    await CTALogTypeSave({
      data: {
        ...CTALogType,
        name: nameValue,
      },
      success: (data) => {
        toastSuccess('A lista de tipos CTA foi atualizada com sucesso');
        setIsLoading(false);
        handleCloseModal();
        dispatch({
          type: 'SET_RELOAD',
          payload: !state.reload,
        });
      },
      error: (error) => {
        toastError('Ocorreu um erro ao submeter o tipo');
        setIsLoading(false);
      },
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!formIsValid) {
      validateAllFormInputs();
      return;
    }

    saveCTALogType();
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col>
            <DefaultInput
              label={'Nome'}
              name={'name'}
              required={true}
              type={'text'}
              value={nameValue}
              onChange={nameChangeHandler}
              onBlur={nameBlurHandler}
              hasError={nameHasError}
              errorMessage={isMandatoryMessage}
            />
          </Col>
        </Row>
        <Row>
          <Col className="text-end">
            <Button type={'submit'}>Submeter</Button>
          </Col>
        </Row>
      </Form>
      {isLoading && <Loading label={'A carregar...'} />}
    </>
  );
}
